import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { changeTableSettings } from '../../../../../../redux/settings/id8/Id8SettingsReducer';
import calculateSortStr from '../../../../../../utils/calculateSortValue';
import { MODAL_TYPES } from '../../../../../../constants';
import CommonTable from '../../../../../../components/common-table/CommonTable';
import AgentTableItem from './AgentTableItem';
import Tr from '../../../../../../components/common-table/components/Tr';
import Th from '../../../../../../components/common-table/components/Th';
import ThWithSort from '../../../../../../components/common-table/components/ThWithSort';
import CommonPagination from '../../../../../../components/common-pagination/CommonPagination';
import ConfirmationModal from '../../../../../../components/confirmation-modal/ConfirmationModal';
import DeleteLabel from '../../../../../../projects/projects-list/components/DeleteLabel';
import AgentInfoModal from './AgentInfoModal';
import { deleteAgent, getAgents } from '../../../../../../redux/settings/id8/id8SettingsActions';

import scss from '../AgentList.module.scss';

function AgentTable() {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.id8Settings.isAgentsLoading);
  const agents = useSelector((state) => state.id8Settings.agentsList);
  const tableSettings = useSelector((state) => state.id8Settings.tableSettings);

  const [selectedModalData, setSelectedModalData] = useState({});

  const handleCloseModals = () => {
    setSelectedModalData({});
  };

  const handleOpenDeleteModal = (agent) => {
    setSelectedModalData({ agent, type: MODAL_TYPES.DELETE });
  };

  const handleOpenInfoModal = (agent) => {
    setSelectedModalData({ agent, type: MODAL_TYPES.INFO });
  };

  const handleDeleteProject = async () => {
    await dispatch(deleteAgent({ id: selectedModalData.agent.id }));
    handleCloseModals();
  };

  const handleChangeTablePage = (newPage) => {
    dispatch(changeTableSettings({ page: newPage }));
  };

  useEffect(() => {
    dispatch(getAgents());
  }, [tableSettings.sort, tableSettings.search, tableSettings.page, tableSettings.size, dispatch]);

  return (
    <div>
      <CommonTable
        content={agents}
        isLoading={isLoading}
        renderBody={(item) => (
          <AgentTableItem key={item.id} agent={item} onDelete={handleOpenDeleteModal} onPreview={handleOpenInfoModal} />
        )}>
        <Tr>
          <Th extraClasses='cell-rank'>#</Th>
          <Th extraClasses={scss.cellName} isLeft>
            {t('agentName')}
          </Th>
          <Th isLeft extraClasses={scss.cellInstructions}>
            {t('instructions')}
          </Th>
          <Th extraClasses={scss.cellAction} isLeft>
            {t('actions')}
          </Th>
        </Tr>
      </CommonTable>

      <div className={scss.paginationWrapper}>
        <CommonPagination
          activePage={tableSettings.page}
          itemsPerPage={tableSettings.size}
          totalItemsCount={tableSettings.totalElements}
          onChangePage={handleChangeTablePage}
        />
      </div>

      <ConfirmationModal
        isOpen={selectedModalData.type === MODAL_TYPES.DELETE}
        onClose={handleCloseModals}
        onCancel={handleCloseModals}
        onConfirm={handleDeleteProject}
        subLabel={<DeleteLabel name={selectedModalData.agent?.name} />}
      />

      <AgentInfoModal
        isOpen={selectedModalData.type === MODAL_TYPES.INFO}
        onClose={handleCloseModals}
        agent={selectedModalData?.agent}
      />
    </div>
  );
}

export default AgentTable;
